import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getFreespinOperation = (params) => {
    return axios.get(`${backendHost}/api/admin/freespin/list_id`, {params});
};

export {
    getFreespinOperation
}